import React from "react";

export function PageShell({ eyebrow = "Platform Operations", title, subtitle, actions, children, testid }) {
  return (
    <div className="p-6 lg:p-8 space-y-6" data-testid={testid}>
      <div className="flex items-start justify-between flex-wrap gap-3">
        <div>
          <div className="label-eyebrow mb-1">{eyebrow}</div>
          <h1 className="font-display text-3xl font-bold tracking-tight">{title}</h1>
          {subtitle && <p className="text-muted-foreground text-sm mt-1 max-w-2xl">{subtitle}</p>}
        </div>
        {actions}
      </div>
      {children}
    </div>
  );
}

export function Stat({ icon: Icon, label, value, sub, tone }) {
  const toneCls = tone === "accent" ? "text-accent" : tone === "red" ? "text-red-400" : tone === "amber" ? "text-amber-400" : "";
  return (
    <div className="card-flat p-4">
      <div className="flex items-center gap-2 text-muted-foreground mb-2">
        {Icon && <Icon className="h-4 w-4" />}<span className="label-eyebrow text-[10px]">{label}</span>
      </div>
      <div className={`font-mono text-2xl font-bold ${toneCls}`}>{value}</div>
      {sub && <div className="text-[11px] text-muted-foreground mt-1">{sub}</div>}
    </div>
  );
}
